(function () {
  'use strict';

  var SIZE_LABEL_PATTERN = /^(size|maat|gr[oö]ße|taille|tama[nñ]o|dimensioni|tamanho)\b/i;
  var INJECTED_FLAG = 'sizeChartInjected';

  function getChartSource() {
    var el = document.querySelector('[data-size-chart-source]');
    if (el && el.innerHTML.trim()) return el.innerHTML.trim();

    // Fallback: some product templates never render product-description.liquid,
    // so no <template data-size-chart-source> is emitted. On those, the theme
    // has already built the chart server-side into the NATIVE Size variant
    // label (snippets/variant-button.liquid, connect_to_sizechart) - which the
    // swatch app then hides. Reuse that content. Skip .size-chart__standalone:
    // that block's content is a store-wide page, not this product's chart.
    var triggers = document.querySelectorAll('tool-tip-trigger[data-tool-tip="size-chart"]');
    for (var i = 0; i < triggers.length; i++) {
      if (triggers[i].closest && triggers[i].closest('.size-chart__standalone')) continue;
      var content = triggers[i].querySelector('[data-tool-tip-content]');
      if (content && content.innerHTML.indexOf('<table') !== -1) return content.innerHTML.trim();
    }
    return '';
  }

  function getChartTitle() {
    var label = (window.theme && window.theme.strings && window.theme.strings.sizeChart) || 'Size chart';
    var icon = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-size-chart" viewBox="0 0 64 64" style="width:1.4em;height:1.4em;vertical-align:middle;"><path d="M22.39 33.53c-7.46 0-13.5-3.9-13.5-8.72s6-8.72 13.5-8.72 13.5 3.9 13.5 8.72a12 12 0 0 1-.22 1.73"/><ellipse cx="22.39" cy="24.81" rx="3.28" ry="2.12"/><path d="M8.89 24.81V38.5c0 7.9 6.4 9.41 14.3 9.41h31.92V33.53H22.39m24.39 0v7.44m-8.13-7.44v7.44m-8.13-7.44v7.44m-8.13-7.44v7.44"/></svg>';
    return label + ' ' + icon;
  }

  function isSizeLabelText(text) {
    return !!text && SIZE_LABEL_PATTERN.test(text.trim());
  }

  function buildTriggerHtml() {
    return (
      '<span class="variant__label-info size-chart-trigger-injected" style="margin-left:0.4em;">' +
        '&mdash;&nbsp; ' +
        '<button type="button" class="tool-tip-trigger" data-size-chart-trigger style="font-size:1.008em;vertical-align:baseline;">' +
          '<span class="tool-tip-trigger__title">' + getChartTitle() + '</span>' +
        '</button>' +
      '</span>'
    );
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getProductName() {
    var el = document.querySelector('.product-single__title, .product__title');
    var name = el ? el.textContent.trim() : '';
    if (!name) {
      var attrEl = document.querySelector('[data-product-title]');
      if (attrEl) name = (attrEl.getAttribute('data-product-title') || '').trim();
    }
    if (!name) {
      name = (document.title || '').split(/\s+[–|]\s+/)[0].trim();
    }
    if (name.length > 120) name = '';
    return name;
  }

  function buildPopupContent(chartHtml) {
    var productName = getProductName();
    return (
      '<div style="text-align:center;margin-bottom:1em;">' +
        (productName ? '<h2 style="margin:0 0 0.25em;font-size:1.4em;">' + escapeHtml(productName) + '</h2>' : '') +
        '<div style="font-size:0.9em;letter-spacing:0.1em;text-transform:uppercase;opacity:0.7;">Size chart</div>' +
      '</div>' +
      '<hr style="border:0;border-top:1px solid currentColor;opacity:0.2;margin:0 0 1em;">' +
      '<div class="size-chart-unit-toggle" role="group" aria-label="Unit">' +
        '<button type="button" class="size-chart-unit-btn is-active" data-size-chart-unit="in" aria-pressed="true">INCH</button>' +
        '<button type="button" class="size-chart-unit-btn" data-size-chart-unit="cm" aria-pressed="false">CM</button>' +
      '</div>' +
      '<p style="font-size:0.9em;font-style:italic;text-align:center;margin:0 0 1em;opacity:0.8;">If you\'re in between sizes, we recommend going one size up for extra comfort.</p>' +
      '<div class="size-chart-table-wrap" data-size-chart-unit="in">' + chartHtml + '</div>'
    );
  }

  var HAS_DIGIT_RE = /\d/;
  var IN_LABEL_RE = /\bin(?:ch(?:es)?)?\b\.?/gi;

  function inchesToCm(num) {
    // Montela only: operator asked for floor, not round - the converted cm was
    // reading high against the supplier's UK SIZE GUIDE. One decimal, because
    // whole-cm rounding collapses adjacent shoe sizes onto the same length.
    var cm = Math.floor(num * 2.54 * 10) / 10;
    return String(cm).replace(/\.0$/, '');
  }

  // Columns that hold SIZE LABELS (UK / EU / US ...) must never be unit-converted.
  var NO_CONVERT_HEADER_RE = /^\s*(uk|eu|eur|us|size|maat|gr[oö]sse|gr[oö]ße|taille|talla|tamanho)\b/i;

  function noConvertColumns(wrap) {
    var set = {};
    var table = wrap ? wrap.querySelector('table') : null;
    if (!table) return set;
    var row = table.querySelector('thead tr') || table.querySelector('tr');
    if (!row) return set;
    var cells = row.children;
    for (var i = 0; i < cells.length; i++) {
      if (NO_CONVERT_HEADER_RE.test(cells[i].textContent || '')) set[i] = true;
    }
    return set;
  }

  function convertNumericCells(wrap, unit) {
    if (!wrap || wrap.getAttribute('data-size-chart-unit') === unit) return;
    var skip = noConvertColumns(wrap);
    var rows = wrap.querySelectorAll('tr');
    for (var r = 0; r < rows.length; r++) {
      var cells = rows[r].children;
      for (var i = 0; i < cells.length; i++) {
        var cell = cells[i];
        if (skip[i] || cell.hasAttribute('data-no-convert')) continue;
        var original = cell.getAttribute('data-in-text');
        if (original === null) {
          var text = cell.textContent;
          IN_LABEL_RE.lastIndex = 0;
          if (!HAS_DIGIT_RE.test(text) && !IN_LABEL_RE.test(text)) {
            IN_LABEL_RE.lastIndex = 0;
            continue;
          }
          IN_LABEL_RE.lastIndex = 0;
          original = text;
          cell.setAttribute('data-in-text', original);
        }
        if (unit === 'cm') {
          var converted = original.replace(/\d+(?:\.\d+)?/g, function (n) {
            return inchesToCm(parseFloat(n));
          });
          IN_LABEL_RE.lastIndex = 0;
          converted = converted.replace(IN_LABEL_RE, 'cm');
          IN_LABEL_RE.lastIndex = 0;
          cell.textContent = converted;
        } else {
          cell.textContent = original;
        }
      }
    }
    wrap.setAttribute('data-size-chart-unit', unit);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-size-chart-unit]');
    if (!btn || btn.tagName !== 'BUTTON') return;
    var unit = btn.getAttribute('data-size-chart-unit');
    var toggle = btn.parentElement;
    if (!toggle || !toggle.classList.contains('size-chart-unit-toggle')) return;
    e.preventDefault();
    var siblings = toggle.querySelectorAll('.size-chart-unit-btn');
    for (var i = 0; i < siblings.length; i++) {
      var s = siblings[i];
      var active = s === btn;
      s.classList.toggle('is-active', active);
      s.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
    var container = toggle.parentElement;
    var wrap = container ? container.querySelector('.size-chart-table-wrap') : null;
    convertNumericCells(wrap, unit);
  });

  function injectNextToOptionName(nameSpan, chartHtml) {
    if (!nameSpan || nameSpan.dataset[INJECTED_FLAG] === '1') return;
    nameSpan.dataset[INJECTED_FLAG] = '1';
    nameSpan.insertAdjacentHTML('afterend', buildTriggerHtml());

    var injected = nameSpan.nextElementSibling;
    if (!injected || !injected.classList.contains('size-chart-trigger-injected')) return;

    injected.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });

    var button = injected.querySelector('[data-size-chart-trigger]');
    if (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        document.dispatchEvent(new CustomEvent('tooltip:open', {
          bubbles: true,
          detail: { context: 'size-chart', content: buildPopupContent(chartHtml) }
        }));
      });
    }
  }

  function scan(root, chartHtml) {
    var nodes = (root || document).querySelectorAll('.swatch-option-name');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!isSizeLabelText(node.textContent)) continue;
      injectNextToOptionName(node, chartHtml);
    }
  }

  function init() {
    var chartHtml = getChartSource();
    if (!chartHtml) return;

    scan(document, chartHtml);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('.swatch-option-name')) {
            if (isSizeLabelText(node.textContent)) injectNextToOptionName(node, chartHtml);
          } else if (node.querySelector) {
            scan(node, chartHtml);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
